<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps<{
  show: boolean
  multiplier: number
}>()

const isVisible = ref(false)
const hideTimeout = ref<ReturnType<typeof setTimeout> | null>(null)

watch(() => props.show, (show) => {
  if (show && props.multiplier > 1) {
    if (hideTimeout.value) {
      clearTimeout(hideTimeout.value)
    }
    isVisible.value = true
    hideTimeout.value = setTimeout(() => {
      isVisible.value = false
    }, 1000)
  }
}, { immediate: true })
</script>
<template>
  <Transition name="slide-fade">
    <div
      v-if="isVisible && multiplier > 1"
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[95] flex items-center gap-x-3 pl-4 pr-1.5 py-1 rounded-[35px] bg-dark-bottom-layer border border-white/[.12] shadow-lg"
    >
      <span class="text-white font-bold text-lg uppercase tracking-wide whitespace-nowrap">All Rewards</span>
      <span class="bg-[#FAA101] text-white/[.87] text-lg font-bold px-2 py-0.5 rounded-[37px]">
        x{{ multiplier }}
      </span>
    </div>
  </Transition>
</template>
<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-in;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.9);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -100%) scale(0.9);
}
</style>
